"use strict";

const CHILD_ROW_CLASS = "child-row";
const CHILD_ROW_COLUMNS = [
    {
        label: "Record creation date",
        name: "record_creation_date"
    },
    {
        label: "Last update date",
        name: "last_update_date"
    },
    {
        label: "Expiry date",
        name: "expiry_date"
    },
    {
        label: "Full legal name",
        name: "full_legal_name"
    },
    {
        label: "Registered address",
        name: "registered_address"
    },
    {
        label: "Operational address",
        name: "operational_address"
    },
    {
        label: "Branch description",
        name: "branch_description"
    },
    {
        label: "Branch address",
        name: "branch_address"
    },
    {
        label: "Institution type",
        name: "institution_type"
    }
];

const elements = require("client/pages/bicsearch/elements");
const staticData = require("client/static_data");
const revealBanner = require("client/reveal_banner");
const mandatoryFields = new Set(["bic", "institution_name"]);

function _disableFields () {
    const inputs = _getInputs(elements.form);
    for (const input of inputs) {
        input.setAttribute("disabled", "");
    }
    // const dropDown = _getCountryDropDown();
    // if (dropDown) {
    //     dropDown.setAttribute("disabled", "");
    // }

}

elements.table.addEventListener("click", _toggleChildRows);
function _toggleChildRows (event) {
    const target = event.target;
    if ("details" in target.dataset) {
        event.preventDefault();

        const details = JSON.parse(target.dataset.details);
        const row = target.closest("tr");

        if (row.nextElementSibling?.classList.contains(CHILD_ROW_CLASS)) {
            row.nextElementSibling.remove();
        } else {
            const childRow = document.createElement("tr");
            childRow.className = CHILD_ROW_CLASS;
            const childCell = document.createElement("td");
            childCell.colSpan = row.cells.length;

            childCell.appendChild(_renderDetailsTable(details));
            childRow.appendChild(childCell);
            row.parentNode.insertBefore(childRow, row.nextElementSibling);
        }
    }
}
function _renderDetailsTable (details) {
    if (!details) {
        details = {};
    }

    const table = document.createElement("table");
    for (const column of CHILD_ROW_COLUMNS) {
        const value = details.hasOwnProperty(column.name) ? details[column.name] : "";
        table.appendChild(_renderDetailRow(column.label, value));
    }

    return table;
}
function _renderDetailRow (label, value) {

    let tr = document.createElement("tr");
    let tdLabel = document.createElement("td");
    tdLabel.innerText = label;
    tdLabel.style.minWidth = "180px";
    let tdLValue = document.createElement("td");
    tdLValue.innerText = value;
    tr.appendChild(tdLabel);
    tr.appendChild(tdLValue);
    return tr;
}
// function _getCountryDropDown () {
//     return document.querySelector('swiftref-dropdown[name="country_code"]');
// }
function _getInputs (container) {
    if (container) {
        const inputs = Array.from(container.querySelectorAll("swiftref-input"));
        const dropdowns = Array.from(container.querySelectorAll("swiftref-dropdown"));
        const checkboxes = Array.from(container.querySelectorAll("swiftref-checkbox"));
        return inputs.concat(dropdowns, checkboxes);
    }
}
// function _getWarningBanner() {
//     return document.querySelector("swiftref-banner");
// }

/**
 * `reveal` (default true) scrolls to the banner and focuses it (client/reveal_banner.js:
 * on a phone the page sits where the dialog's link was, above-the-fold messages go
 * unseen): pass false for a message rendered at page load, where the focus belongs
 * to the page.
 * Idempotent for an unchanged message: the machine's renderMessage action runs
 * on every idle/ready entry (every form keystroke), and re-rendering would steal
 * the focus from the field being typed in.
 */
function _renderBanner({state, text, clear_icon, append, reveal}) {
    const current = elements.banner_container.querySelector("swiftref-banner");
    if (append !== true && current && elements.banner_container.children.length === 1
        && current.getAttribute("state") === (state || "success") && current.dataset.text === (text || "")) {
        return;
    }
    if (append !== true) {
        elements.banner_container.innerHTML = "";
    }
    const banner = document.createElement("swiftref-banner");
    banner.setAttribute("state", state || "success");
    banner.innerHTML = text || "";
    // the raw text, for the idempotence check: innerHTML re-serializes entities
    banner.dataset.text = text || "";
    elements.banner_container.appendChild(banner);
    if (clear_icon && clear_icon === true) {
        banner.setAttribute("clear_icon", "");
    }
    if (reveal !== false) {
        revealBanner(elements.banner_container, banner);
    }
}


/**
 * A message inside the txt directory dialog, above the form, for a rejection
 * that marks no field (schema-level, or no answer at all): the page banner sits
 * behind the overlay, which on a phone covers the whole screen.
 */
function _renderDialogMessage (text) {
    if (!elements.dialog_message) {
        return;
    }
    elements.dialog_message.innerHTML = "";
    const banner = document.createElement("swiftref-banner");
    banner.setAttribute("state", "warning");
    banner.textContent = text || "";
    elements.dialog_message.appendChild(banner);
    elements.txt_file_dialog.scrollTop();
}

function _clearDialogMessage () {
    if (elements.dialog_message) {
        elements.dialog_message.innerHTML = "";
    }
}

/**
 * Submit sits in the dialog footer, so the content is scrolled to the bottom
 * when a rejection comes back and the first marked field is above the fold:
 * bring it into view (the dialog's content box is the scrolling ancestor).
 */
function _revealFirstInvalidField () {
    const field = elements.txt_file_dialog.querySelector('[state="invalid"]');
    if (field) {
        field.scrollIntoView({block: "center"});
    }
}

/**
 * Enter in a dialog text field moves the focus to the next field, which is
 * what the keyboard's "next" key (enterkeyhint, see the view) promises. The
 * keyboard event is composed, so it reaches the dialog host from inside the
 * input's shadow root, retargeted to the swiftref-input host.
 */
function _focusNextFieldOnEnter (event) {
    if (event.key !== "Enter" || event.target?.tagName !== "SWIFTREF-INPUT") {
        return;
    }
    const fields = Array.from(elements.txt_file_dialog.querySelectorAll("swiftref-input, swiftref-dropdown"));
    const next = fields[fields.indexOf(event.target) + 1];
    if (next && typeof next.focus === "function") {
        event.preventDefault();
        next.focus();
    }
}

/**
 * The page listens for Enter on the document to start a search: an Enter
 * typed inside the dialog must not reach it (a search would start behind the
 * open dialog), so the dialog host stops it.
 */
function _keepEnterInsideDialog (event) {
    if (event.key === "Enter") {
        event.stopPropagation();
    }
}

function _getMandatoryFields () {

    const form = {};
    for (const f of mandatoryFields) {
        const field = document.querySelector(`swiftref-input[name="${f}"]`);
        if (field.value) {
            form[field.name] = field.value;
        }
    }
    return form;
}

const presentation = {

        "bindEventListeners": function (actor) {
            function _getCaptcha () {
                actor.send({"type": "GET_CAPTCHA"});
            }
            if (elements.refreshCaptchaButton) {
                elements.refreshCaptchaButton.addEventListener("click", _getCaptcha);
            }

            if (elements.pagination) {
                // add event listener to the pagination widget
                elements.pagination.addEventListener("change", function (event) {
                    // prevent to scroll after clicking on pagination (feedback from Fra)
                    event.preventDefault();
                    const payload = event.detail;
                    if (payload.current_page) {
                        /**
                         * By directly triggering the same callback function used for the onclick
                         * event, we explicitly do not give the event first param.
                         *
                         * @author Simone Sacchi
                         * @version 2025/10/13
                         */
                        const event = null;
                        _search(event, {
                            "current_page": payload.current_page
                        });
                    }
                });
            }


            function _search (event, payload = {}) {
                const fields = _getInputs(elements.form);
                for (const field of fields) {
                    payload[field.getAttribute("name")] = field.value;
                }
                actor.send({"type": "SEARCH", payload});
            }
            function _onKeyUp (event) {
                if (event.key === "Enter") {
                    _search();
                }
            }

            // const warningBanner = _getWarningBanner();
            if (staticData.number_of_requests_exceeded) {
                _renderBanner({
                    state: "warning",
                    text: staticData.errors.NUMBER_OF_REQUESTS_EXCEEDED_FOR_CAPTCHA.message,
                    reveal: false
                });
                _disableFields();
            } else {
                if (elements.searchJs) {
                    elements.searchJs.addEventListener("click", _search);
                }

                document.addEventListener("keyup", _onKeyUp);
            }
            // if (staticData.number_of_txt_email_exceeded) {
            //     _renderBanner({
            //         state: "warning",
            //         text: staticData.errors.NUMBER_OF_TXT_EMAIL_EXCEEDED.message,
            //         append: true
            //     });
            // }


            if (elements.form) {
                elements.form.addEventListener("input", function (event) {
                    const name = event.target.name;
                    if (mandatoryFields.has(name)) {
                        actor.send({
                            "type": "CHECK_REQUIRED_FIELDS",
                            "payload": {
                                "form": _getMandatoryFields()
                            }
                        });
                    }
                });
            }



            if (elements.page_wrapper) {
                elements.page_wrapper.addEventListener("click", function (event) {
                    const target = event.target;
                    const action = target.dataset.action;

                    switch (action) {

                        case "reset-search":
                            window.location = `${staticData.base_url}/${staticData.lang}/bicsearch`;
                            return;

                        case "download-pdf": {
                            event.preventDefault();
                            const href = target.href;
                            if (href) {
                                const payload = {href};
                                document.dispatchEvent(
                                    new CustomEvent('DOWNLOAD_FILE', { "detail": payload })
                                );
                            }
                            return;
                        }


                        case "send-txt-email": {

                            const fields = _getInputs(elements.txt_file_dialog);
                            const payload = {};
                            for (const field of fields) {
                                if (field.tagName === "swiftref-checkbox".toLocaleUpperCase()) {
                                    payload[field.getAttribute("name")] = field.checked;
                                } else {
                                    payload[field.getAttribute("name")] = field.value || "";
                                }
                            }
                            actor.send({
                                "type": "SEND_TXT_EMAIL",
                                "payload": payload
                            });
                            return;
                        }

                        case "open-dialog": {

                            const {value, context} = actor.getSnapshot();
                            if (context.number_of_txt_email_exceeded === true) {
                                _renderBanner({
                                    state: "warning",
                                    text: staticData.errors.NUMBER_OF_TXT_EMAIL_EXCEEDED.message
                                });
                            } else {
                                actor.send({
                                    "type": "OPEN_TXT_FILE_DIALOG",
                                    "payload": {
                                        "previous_state": value
                                    }
                                }, {});
                            }

                            return;
                        }

                        default:
                            return;
                    }

                });
            }


            elements.txt_file_dialog.addEventListener("hide", function () {
                actor.send({
                    "type": "CLOSE"
                }, {});
            });
            elements.txt_file_dialog.addEventListener("keydown", _focusNextFieldOnEnter);
            elements.txt_file_dialog.addEventListener("keyup", _keepEnterInsideDialog);
        },
        // bic and institution_name are mandatory only if the other field is empty
        "toggleRequirementOnField": function (form) {
            let onceHasValue = false;
            for (const field of mandatoryFields) {
                const inputElement = document.querySelector(`swiftref-input[name="${field}"]`);
                if (inputElement) {
                    if (form[field]) {
                        onceHasValue = true;
                    } else {
                        inputElement.removeAttribute("required");
                    }
                }
            }
            if (!onceHasValue) {
                for (const field of mandatoryFields) {
                    const inputElement = document.querySelector(`swiftref-input[name="${field}"]`);
                    if (inputElement) {
                        inputElement.setAttribute("required", "");
                    }
                }
            }
        },
        "showTable": function () {
            if (elements.table_wrapper) {
                elements.table_wrapper.style.visibility = "visible";
            }
        },
        "hideTable": function () {
            if (elements.table_wrapper) {
                elements.table_wrapper.style.visibility = "hidden";
            }
        },
        "enableSearch": function () {
            /**
             * The search limit is the machine's to decide (readyOnEntry): this used
             * to refuse whenever ANY banner was shown, so an expired download link
             * or a sent email blocked every search.
             */
            if (elements.searchJs) {
                elements.searchJs.removeAttribute("disabled");
            }
            if (elements.pagination) {
                elements.pagination.removeAttribute("disabled");
            }
            const getCaptchaIcon = document.querySelector('swiftref-icon[kind="rotate"]');
            if (getCaptchaIcon) {
                getCaptchaIcon.removeAttribute("disabled");
            }
        },
        "disableSearch": function () {
            if (elements.searchJs) {
                elements.searchJs.setAttribute("disabled", "disabled");
            }
            if (elements.pagination) {
                elements.pagination.setAttribute("disabled", "");
            }
            const getCaptchaIcon = document.querySelector('swiftref-icon[kind="rotate"]');
            if (getCaptchaIcon) {
                getCaptchaIcon.setAttribute("disabled", "");
            }
        },
        "clearErrors": function (container ) {
            container = container || elements.form;
            if (container === elements.txt_file_dialog) {
                _clearDialogMessage();
            }
            const inputs = _getInputs(container);
            for (const input of inputs) {
                input.removeAttribute("message");
                input.removeAttribute("state");
            }
        },
        "clearBanner": function () {
            elements.banner_container.innerHTML = "";
        },
        "clearInputsValue": function (container ) {
            container = container || elements.form;
            const inputs = _getInputs(container);
            for (const input of inputs) {
                if (input.tagName === "SWIFTREF-CHECKBOX") {
                    input.checked = false;
                } else {
                    input.value = "";
                }

            }
        },
        "showCaptcha": function () {
            if (elements) {
                elements.captcha_container.style.display = "block";
            }

        },
        "renderCaptcha": function (captchaSvgString) {
            if (elements.captcha_container && captchaSvgString) {
                const captchaSvg = elements.captcha_container.querySelector("svg");
                captchaSvg.outerHTML = captchaSvgString;
                presentation.showCaptcha();
                const input = document.querySelector(`swiftref-input[name="challenge"]`);
                input.value = "";
            }
        },
        "renderErrors": function (context) {

            const error = context.error;
            let reported = false;
            if (error.fields) {
                for (const fieldName in error.fields) {
                    const input = document.querySelector(`swiftref-input[name="${fieldName}"]`);
                    const message = error.fields[fieldName];

                    if (input) {
                        input.setAttribute("state", "invalid");
                        input.setAttribute("message", message);
                        reported = true;
                    }
                }
            }
            else if (error.name && error.name === staticData.errors.NUMBER_OF_REQUESTS_EXCEEDED.name) {
                reported = true;
                // const warningBanner = _getWarningBanner();
                // warningBanner.classList.remove("invisible");
                _renderBanner({
                    state: "warning",
                    text: staticData.errors.NUMBER_OF_REQUESTS_EXCEEDED.message
                });
                _disableFields();
                if (elements.searchJs) {
                    elements.searchJs.setAttribute("disabled", "disabled");
                    // elements.searchJs.removeEventListener("click", _search);
                }
                // document.removeEventListener("keyup", _onKeyUp);
                if (elements.refreshCaptchaButton) {
                    elements.refreshCaptchaButton.setAttribute("disabled", "disabled");
                    // elements.refreshCaptchaButton.removeEventListener("click", _getCaptcha);
                }

            }
            /**
             * An error with no field to mark (a server error, or no answer at all)
             * would leave the page visually unchanged: report it on the page banner,
             * as the txt directory dialog does. The next search clears it.
             */
            if (!reported) {
                _renderBanner({
                    state: "warning",
                    text: staticData.errors.INVALID_PARAMS.message
                });
            }
            if (context.captcha) {
                presentation.renderCaptcha(context.captcha);
            }
        },
        "renderDialogErrors": function (context) {
            const error = context.dialog_form_error;
            const inputs = _getInputs(elements.txt_file_dialog);
            const inputsByName = {};
            for (const input of inputs) {
                inputsByName[input.name] = input;
            }
            let marked = false;
            if (error.fields) {
                for (const fieldName in error.fields) {
                    const input = inputsByName[fieldName];
                    const message = error.fields[fieldName];

                    if (input) {
                        input.setAttribute("state", "invalid");
                        input.setAttribute("message", message);
                        marked = true;
                    }
                }
            }
            /**
             * An error with no field to mark (a server error, or no answer at all)
             * would leave the dialog visually unchanged: report it inside the
             * dialog, as the BIC-to-LEI dialog does.
             */
            if (marked) {
                _revealFirstInvalidField();
            } else {
                _renderDialogMessage(error.name === staticData.errors.UNABLE_TO_SEND_EMAIL.name
                    ? staticData.errors.UNABLE_TO_SEND_EMAIL.message
                    : staticData.errors.INVALID_PARAMS.message);
            }
        },
        "clearData": function () {
            const tbody = elements.table.querySelector("tbody") || elements.table.createTBody();
            tbody.innerText = '';
        },

        "renderData": function (state) {

            presentation.clearErrors();
            if (elements.captcha_container) {
                elements.captcha_container.style.display = "none";
            }
            /**
             * A success payload can reach this renderer without an array `data`
             * (an upstream anomaly, a proxy rewriting the response): iterate an
             * empty list and show 0 results rather than throwing inside the
             * xstate subscriber — the throw killed the whole page render.
             *
             * @see LEARNED.md
             */
            const data = Array.isArray(state.data) ? state.data : [];
            const count = typeof state.count === "number" ? state.count : data.length;
            this.clearData();
            const tbody = elements.table.querySelector("tbody") || elements.table.createTBody();

            elements.pagination.style.visibility = "hidden";
            elements.table.style.visibility = "hidden";

            for (const datum of data) {
                const tr = document.createElement("tr");
                let td = document.createElement("td");
                const link = document.createElement("a");
                link.innerText = datum.bic;
                link.setAttribute("href", "");
                link.dataset.details = JSON.stringify(datum);
                link.className = "subtle";
                td.appendChild(link);
                tr.appendChild(td);
                td = document.createElement("td");
                td.innerText = datum.institution_name;
                tr.appendChild(td);
                td = document.createElement("td");
                td.innerText = datum.city || "";
                tr.appendChild(td);
                td = document.createElement("td");
                td.innerText = datum.country_name;
                tr.appendChild(td);
                tbody.appendChild(tr);
            }

            elements.info_text.innerText = `${staticData.texts["Search results"]}: ${count} ${count === 1 ? 'BIC' : 'BICs'} ${staticData.texts["found"]}`;

            if (data.length) {
                elements.pagination.current_page = (state.offset / state.limit) + 1;
                elements.pagination.last_page = Math.ceil(count / state.limit);
                elements.pagination.style.visibility = "inherit";
                elements.table.style.visibility = "inherit";
            }

            presentation.showTable();
        },
        "getMandatoryFields": _getMandatoryFields,
        "openTxtFileDialog": function () {
            elements.txt_file_dialog.show();
        },
        "closeTxtFileDialog": function () {
            elements.txt_file_dialog.hide();
            const container = elements.txt_file_dialog;
            presentation.clearErrors(container);
            presentation.clearInputsValue(container);
        },
        "renderBanner": _renderBanner
    };


module.exports = presentation;


document.addEventListener('DOWNLOAD_FILE_ERROR', (e) => {
    // const warningBanner = _getWarningBanner();
    // warningBanner.classList.remove("invisible");
    // // warningBanner.setAttribute("clear_icon", "");
    // warningBanner.setAttribute("text", e.detail.error);
    _renderBanner({
        state: "warning",
        text: e.detail.error
    });
});
